var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520.27 130.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.44,73.66c12.65,0,20-6.41,20-18.57,0-12-7.4-18.07-20-18.07H29.25V73.66Zm.82,23h-23V129H0V14H51.44c30.4,0,47.82,14.46,47.82,40.1,0,17.58-7.4,30.23-20.87,37l24.15,38H69.35L52.26,96.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.81,40.47h28.27V129H118.81ZM148.06,15c0,8.87-6.24,15.11-14.95,15.11s-15-6.24-15-15.11c0-8.71,6.24-15,15-15s14.95,6.25,14.95,15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.12,73.17V129H291.85V81c0-10.52-5.91-16.93-15.28-16.93-10.68.33-17.25,9-17.25,21V129H230.89V81c0-10.52-5.76-16.93-15.12-16.93-10.85.33-17.59,9-17.59,21v43.87H169.92V40.47h28.26V55.09c6.08-10.52,16.27-15.77,29.26-15.94,14.46,0,25.14,7.56,29.58,20.05,5.75-13.15,16.59-19.88,31.22-20.05,19.39,0,31.88,13.31,31.88,34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.53,85c0,13.81,8.05,23,19.88,23,11.67,0,19.72-9.2,19.72-23,0-13.64-8.05-23-19.72-23-11.83,0-19.88,9.37-19.88,23m68.2-.33c0,27.28-19.39,45.36-48.32,45.36-29.08,0-48.48-18.08-48.48-45.36s19.4-45.19,48.48-45.19c28.93,0,48.32,17.91,48.32,45.19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M491.68,61.5c16.76,2.63,28.59,13.64,28.59,31.39,0,22-17.25,37.47-44,37.47-15.77,0-32.37-5.59-42.89-14l11.83-22.19c8.55,9.21,18.41,14,28.76,14,11.5,0,17.75-5.59,17.75-15,0-9.7-6.41-14.46-17.91-14.46H455.36V63.14L481,36.52H439.09V14.17H515v16.6L486.25,60.68l5.42.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.ecb0ad42df450bb3748f85f0be85e825.svg";
export { ForwardRef as ReactComponent };